import axios from '@/plugins/axios'

const apiEndPoint = 'admin/sales-agent'

export default {
    namespaced: true,

    state: {
        stafflist: [],
        daterange: [],
        staffdetail: {},
        page: 0,
        totalPage: 1,
        option: {
            roles: 'staff',
            isVerified: 'approve'
        }
    },

    getters: {

    },

    mutations: {
        setStafflist (state, stafflist) {
            state.stafflist = stafflist
        },
        setStaffdetail (state, staff) {
            state.staffdetail = staff
        },
        setOption (state, optionData) {
            state.option = optionData
        },
        setPage (state, ePage) {
            state.page = ePage
        },
        setTotalPage (state, ePage) {
            state.page = ePage
        }
    },

    actions: {
        async fetchStafflist (context) {
            const response = await axios.post(`${apiEndPoint}?page=${context.state.page}&perPage=50`, context.state.option)
            const stafflist = response
            context.commit('setStafflist', stafflist.content)
            var calTotal = response.totalItems / 50
            this.totalPage = Math.ceil(calTotal)
            return Math.ceil(calTotal)
        },

        async patchStafflist (context) {
            const response = await axios.patch(`${apiEndPoint}/${context.state.staffdetail.id}`, context.state.staffdetail)
            const patchUpdate = response
            console.log(patchUpdate)
        }
    }
}
